import type { AuditFields } from '../types/common';

/**
 * Estrae i 6 campi di audit di Liferay (companyId / groupId / userId / userName /
 * createDate / modifiedDate) da un qualsiasi oggetto che li contiene. I nomi sono
 * identici tra DTO REST e modello UI, quindi lo stesso helper serve entrambe le
 * direzioni (DTO -> UI e UI -> DTO): un solo punto invece del blocco a mano
 * ricopiato in ogni mapper.
 */
export function pickAuditFields(src: AuditFields): AuditFields {
  return {
    companyId: src.companyId,
    groupId: src.groupId,
    userId: src.userId,
    userName: src.userName,
    createDate: src.createDate,
    modifiedDate: src.modifiedDate,
  };
}
